import { ReservationTypeEnum } from './reservation-type.model';

export enum MarkerTypeEnum {
    Accommodation = 'accommodation',
    Cluster = 'cluster',
}

interface MarkerBase {
    id: string;
    position: google.maps.LatLngLiteral;
}

export type MarkerDataType = MarkerBase & {
    type: MarkerTypeEnum.Accommodation;
    rate?: number;
    baseRate?: number;
    currency?: string;
    reservationType?: ReservationTypeEnum;
    isCluster?: false;
    cheapestRateCheckIn?: string;
    cheapestRateCheckOut?: string;
    isUnavailable?: boolean;
    isInitiallySelected?: boolean;    
};

export type SelectedAccommodationType = Pick<
    MarkerDataType,
    | 'id'
    | 'rate'
    | 'baseRate'
    | 'currency'
    | 'reservationType'
    | 'cheapestRateCheckIn'
    | 'cheapestRateCheckOut'
    | 'isUnavailable'
>;

export type ClusterType = MarkerBase & {
    type: MarkerTypeEnum.Cluster;
    isCluster: true;
    points: MarkerDataType[];
    count: number;
};

export type ClusterOrMarkerType = MarkerDataType | ClusterType;

export type AccommodationClustersInput = {
    points: MarkerDataType[] | undefined;
    bounds: google.maps.LatLngBoundsLiteral | null;
    zoom: number;
};
